import { CmsApiBlockquoteBlockData } from 'modules/cms/api/types/CmsApiBlockquote';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpBlockquoteBlock } from './CmsAmpBlockquoteBlock';
import { CmsBlockquoteBlock } from './CmsBlockquoteBlock';

export const CmsBlockquoteBlockMapping: CmsBlockMapping<CmsApiBlockquoteBlockData> =
  {
    invariant: [
      {
        prop: 'quote',
        msg: 'Quote required for blockquote',
      },
    ],
    width: CmsBlockWidth.NARROW,
    Component: CmsBlockquoteBlock,
    AmpComponent: CmsAmpBlockquoteBlock,
  };
